function Tuple<const T extends Array<unknown>>(...allParams: T): T {
	return allParams;
}

export { Tuple };
